<div class="mdc-chip" tabindex="0">
	<slot name="leading"></slot>
	<div class="mdc-chip__text"><slot></slot></div>
	<slot name="trailing"></slot>
</div>
